const _ = require('lodash');

/**
 * Validates a value is a boolean.
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @param {Boolean} context.expectedValue The expected boolean value to match against the value being validated.
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name boolean
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null) {
    return Promise.resolve(null);
  }

  if (typeof value !== 'boolean') {
    return Promise.resolve('not-a-boolean');
  }

  let isValid = true;
  if (_.has(context, 'expectedValue')) {
    const { expectedValue } = context;
    isValid = value === expectedValue;
  }

  return Promise.resolve(isValid ? null : 'unexpected-value');
}

module.exports = validate;